import React from 'react'
import Grid from '@material-ui/core/Grid'
import icon from '../img/rocket-icon.png'

// Start Openlayers imports
import { 
    Map,
    View,
    Feature,
 } from 'ol'
import {
    Tile as TileLayer,
    Vector as VectorLayer
} from 'ol/layer'
import {
    Vector as VectorSource,
    XYZ as XYZSource,
} from 'ol/source'
import { 
    ScaleLine,
    ZoomSlider,
    defaults as DefaultControls,
    FullScreen
} from 'ol/control'
import {
    Style,
} from 'ol/style'

import Icon from "ol/style/Icon";
import Point from "ol/geom/Point";
import { transform } from "ol/proj";
import rocketData from "./RocketData";
import $ from "jquery";

// End Openlayers imports

// Hide Div

$(document).ready(function () {
  /* Every time the window is scrolled ... */
  $(window).scroll(function () {
    /* Check the location of each desired element */
    $(".hideme").each(function (i) {
      var bottom_of_object = $(this).offset().top + $(this).outerHeight();
      var bottom_of_window = $(window).scrollTop() + $(window).height();

      /* If the object is completely visible in the window, fade it it */
      if (bottom_of_window > bottom_of_object) {
        $(this).animate({ opacity: "1" }, 1000);
      }
    });
  });
});

var vectorSource = new VectorSource({});

for (var i = 0; i < rocketData.length; i++) {
  var iconFeature = new Feature({
    geometry: new Point(
      transform([rocketData[i][0], rocketData[i][1]], "EPSG:4326", "EPSG:3857")
    ),
  });

  var iconStyle = new Style({
    image: new Icon({
      anchor: [0.5, 0.5],
      anchorXUnits: "fraction",
      anchorYUnits: "pixels",
      opacity: 0.75,
      scale: 0.5,
      src: icon,
    }),
  });

  iconFeature.setStyle(iconStyle);
  vectorSource.addFeature(iconFeature);
}

var fspan = document.createElement('i');
fspan.setAttribute('class', 'fa fa-expand');

var vectorLayer = new VectorLayer({
  source: vectorSource,
});

class OLMap extends React.Component {
  constructor(props) {
    super(props);
    this.updateDimensions = this.updateDimensions.bind(this);
  }
  updateDimensions() {
    const h = window.innerWidth >= 992 ? window.innerHeight : 400;
    this.setState({ height: h });
  }
  componentWillMount() {
    window.addEventListener("resize", this.updateDimensions);
    this.updateDimensions();
  }
  componentDidMount() {
    // Create an Openlayer Map instance with two tile layers
    const map = new Map({
      //  Display the map in the div with the id of map
      target: "map",
      layers: [
        new TileLayer({
          source: new XYZSource({
            url: "https://{a-c}.tile.openstreetmap.org/{z}/{x}/{y}.png",
            projection: "EPSG:3857",
          }),
        }),
        vectorLayer,
      ],
      // Add in the following map controls
      controls: DefaultControls().extend([
        new ZoomSlider(),
        new ScaleLine(),
        new FullScreen(),
      ]),
      // Render the tile layers in a map view with a Mercator projection
      view: new View({
        projection: "EPSG:3857",
        center: [80000, 6670000],
        zoom: 10,
      }),
    });
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  render() {
    const style = {
      width: "75%",
      backgroundColor: "#cccccc",
      
    };
    return (
      <div>
        <div className="container mb-4">
          <div className="row">
          <div className="col-12 mt-1">
            <h2 className="mt-4 mb-4">V2 Rocket Strike Map</h2>
            <div className="col-12">
              This map details the location of V2 Rocket strikes from 8th of
              September 1944, to the final strike on 27th of March 1945. Until
              May 1945 any reporting on the truth behind the mysterious
              explosions around England would have been illegal, newpapers
              were censored from mentioning anything related to the V2 rocket
              strikes. The British government initially attempted to
              conceal the cause of the explosions by blaming them on defective
              gas mains. The public therefore began referring to the V2s as
              “flying gas pipes”, this lead to a lot of early rockets going
              unreported.
              <br></br> <br></br>
              The current information regarding strikes is provided by The Ministry of Home
              Security document titled "Big Ben", and in more recent years,
              eye-witness reports. 
              <br></br>
              <br></br>
              About 3,172 V2 rockets were launched in total. The majority were
              targeted at Belgium and the United Kingdom, over 500 of these
              still remain undocumented. Only with communities coming together
              online does the collection of data continue, shining light on
              something that was once considered so elusive.
              <hr></hr>
              </div>
            </div>
          </div>
        </div>
        <Grid container>
          <Grid item xs={12}>
            <div id="map" className="mb-4 map-container" style={style}></div>
          </Grid>
        </Grid>
        <div className="container mb-4">
          <div className="row">
            <div className="col-12 hideme">
              The total amount of rockets on the map is incomplete and will
              continue to be updated.
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default OLMap;